/**
 * 비밀번호 정책 충족/미충족 실시간 표시 (PC + Mobile 공용)
 *
 * 규칙 SSoT: lib/passwordPolicy.js (서버 utils/passwordPolicy.js 미러)
 * 어떤 조건이 부족한지 보여야 사용자가 고칠 수 있으므로 항목별로 나열한다.
 *
 * ⚠ 비밀번호 값 자체는 표시/로깅하지 않는다 (충족 여부만).
 */
import { Check, X } from 'lucide-react';
import { PASSWORD_RULES, checkPassword } from '../lib/passwordPolicy';

export default function PasswordRequirements({ password = '', className = '' }) {
  const { checks } = checkPassword(password);
  const touched = typeof password === 'string' && password.length > 0;

  return (
    <ul className={`mt-2 space-y-1 ${className}`} aria-label="비밀번호 조건">
      {PASSWORD_RULES.map((rule) => {
        const ok = checks[rule.key];
        // 입력 전에는 중립(회색), 입력 시작 후 충족=초록 / 미충족=빨강
        const tone = !touched ? 'text-gray-400' : ok ? 'text-green-600' : 'text-red-500';
        const Icon = touched && !ok ? X : Check;
        return (
          <li key={rule.key} className={`flex items-center gap-1.5 text-xs ${tone}`}>
            <Icon size={13} className="shrink-0" />
            <span>{rule.label}</span>
            <span className="sr-only">{touched ? (ok ? '충족' : '미충족') : '입력 전'}</span>
          </li>
        );
      })}
    </ul>
  );
}
